(function() {
	'use strict';

	angular
		.module('assetCommon')
		.factory('formatMapper', formatMapper);

	function formatMapper(_, utility, uriUtility, fileMapper, assetCommonConfig) {

		function mapFormat(source, assetId, revisionId) {
			if (!source)
				return undefined;

			if (_.isArray(source))
				return source.map(function (f) { return mapFormat(f, assetId, revisionId); });

			return {
				name: source.name,
				file: source.file && fileMapper.map(source.file, assetId, revisionId),
				files: source.files && fileMapper.map(source.files, assetId, revisionId),
				isSystemFormat: source.name && utility.startsWith(source.name, assetCommonConfig.previewFormatPrefix) || source.name === assetCommonConfig.extractedTextFormatName
			};
		}

		return {
			map: mapFormat
		};
	}
	formatMapper.$inject = ['_', 'utility', 'uriUtility', 'fileMapper', 'assetCommonConfig'];
})();